import dayjs from 'dayjs';

export const mapDateRangeToObj = (date_range: string) => {
  return {
    from_date: dayjs()
      .subtract(isNaN(+(date_range || '')) ? 120 : +(date_range || 12), 'month')
      .format('YYYY-MM-DD'),
    to_date: dayjs().add(1, 'day').format('YYYY-MM-DD'),
  };
};
